module.exports = __webpack_public_path__ + "static/media/WTP_2023.42956254.png";